import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import get from 'lodash/get';

import { Link } from 'formlabs-web-components/Link';

import CountryContext from '../../context/country';
import FlyOutModal from '../modal/FlyOutModal';
import Cart from './Cart';

import cartIcon from '../../../../public/icons/cart.svg';
import cartIconWhite from '../../../../public/icons/cart_white.svg';

import './MenuButton.module.css';
import { InteractiveDiv } from 'formlabs-web-components/Wrapper';

const StoreButton = props => {
  const Button = ({ storePage, t, hasItems, itemCount }) => (
    <Link to={storePage} styleName="button">
      <span styleName="label">{t('Store')}</span>
      {hasItems && <span styleName="badge">{itemCount}</span>}
    </Link>
  );

  if (!props.hasItems) {
    return (
      <div styleName="menu">
        <Button {...props} />
      </div>
    );
  }

  return (
    <FlyOutModal
      modalWidth={340}
      modalContent={<Cart />}
      id="Cart"
      clickTarget={props.storePage}
    >
      <Button {...props} />
    </FlyOutModal>
  );
};

const pickIcon = color => {
  const logos = {
    black: cartIcon,
    white: cartIconWhite
  };

  if (logos[color]) return logos[color];
  return logos['black'];
};

class MenuButton extends Component {
  static contextType = CountryContext;

  state = {
    showCart: false
  };

  handleCartOpen = event => {
    if (this.props.openCart) {
      this.props.openCart();
    }
    this.setState({ showCart: true });
  };

  handleCartClose = event => {
    if (this.props.closeCart) {
      this.props.closeCart();
    }
    this.setState({ showCart: false });
  };

  render() {
    const { items, t, mobile, color, isExternalCartOpen } = this.props;
    const { storePage } = this.context;
    const itemCount = items.length;
    const hasItems = itemCount > 0;

    if (mobile) {
      const icon = <img src={pickIcon(color)} alt={t('Store')} />;

      return (
        <div styleName="mobile">
          {hasItems ? (
            <InteractiveDiv
              handler={
                isExternalCartOpen ? this.handleCartClose : this.handleCartOpen
              }
            >
              {icon}
              <span styleName="badge badge-mobile">{itemCount}</span>
            </InteractiveDiv>
          ) : (
            <Link to={storePage}>{icon}</Link>
          )}
        </div>
      );
    }

    return (
      <StoreButton
        storePage={storePage}
        t={t}
        hasItems={hasItems}
        itemCount={itemCount}
      />
    );
  }
}

export default compose(
  connect(state => {
    return {
      items: get(state, 'cart.totals.items', []),
      storeId: get(state, 'store.id')
    };
  }),
  withTranslation()
)(MenuButton);
